<template>
  <div class="cliplist xm:absolute inset-0 ml-0 xm:ml-4 mt-4 md:mt-0 mr-4 md:mr-0">
    <div v-if="showWarning" class="yellow-fill-border col-xs-12 hidden-xs">
      <i class="sr-2 sr-v2-x close-warn" @click="hideError"></i>
      <p class="video_library">
        Please use
        <a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a> for optimal viewing experience
      </p>
    </div>

    <GradientScroll class="h-full" :gradient-size="30">
      <PublishedClipItem v-for="clip in clips"
                         :clipId="clip.id"
                         :key="clip.id"
      />
    </GradientScroll>
  </div>
</template>

<script>
import PublishedClipItem from "./PublishedClipItem";
import { mapState, mapGetters } from "vuex";
import detectDesktop from "@/utils/detectDesktopBrowser";
import GradientScroll from "@/components/GradientScroll";
import isMobileApp from '@/utils/isMobileApp';

export default {
  components: {
    PublishedClipItem,
    GradientScroll
  },
  data() {
    return {
      allowError: true,
    };
  },
  computed: {
    ...mapState("publishedReelPlayer", ["expandedAllClips"]),
    ...mapGetters("publishedReelPlayer", { clips: "clipsInPlayOrder" }),

    notChrome() {
      return !detectDesktop("chrome");
    },
    showWarning() {
      return this.notChrome && !isMobileApp() && this.allowError;
    }
  },

  methods: {
    hideError() {
      this.allowError = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "styles/_media.scss";

.cliplist {
  border: none;

  @include desktop() {
    min-height: 100%;
  }

  @include mobile() {
    position: relative;
    display: block;
    overflow: hidden;
  }

  .cliplist-items {
    margin-top: 0;
    overflow: auto;
    border-color: #ced4da;
    border-width: 0 0 1px 0;
    @include desktop() {
      border-bottom: none;
    }
  }

  .cliplist-expand {
    color: #286ed7;
    cursor: pointer;
    padding: 10px 12px;
    width: 100%;
    @include desktop() {
      position: absolute;
      bottom: -1px;
      border-top: 1px solid #e0e0e0;
    }
  }
  .scroll-container {
    height: 100%;
    overflow: auto;
    // Sadly we need this for safari hardware acceleration, otherwise clip list will appear blank
    transform: translate3d(0, 0, 0);
    &.-push-down {
      height: calc(100% - 60px);
      width: 100%;
    }
  }

  @keyframes hide {
    0% {
      opacity: 1;
      display: block;
    }
    99% {
      opacity: 0.01;
      display: block;
    }
    100% {
      opacity: 0;
      display: none;
    }
  }
  .yellow-fill-border {
    background-color: #fdecab;
    border: 3px solid #ffe066;
    border-radius: 3px;
  }
  .close-warn {
    float: right;
    color: #ffda4c;
  }
  p.video_library {
    color: rgba(0, 0, 0, 0.5);
    margin: 8px 0;
    font-weight: 300;
    font-size: 12px;
    line-height: 1.6;
  }
  .close-warn {
    cursor: pointer;
  }
}
</style>